import { render, staticRenderFns } from "./InDevelop.vue?vue&type=template&id=10a4c16f"
import script from "./InDevelop.vue?vue&type=script&lang=js"
export * from "./InDevelop.vue?vue&type=script&lang=js"
import style0 from "./InDevelop.vue?vue&type=style&index=0&id=10a4c16f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports